

import React, { useMemo } from 'react';
import PageHeader from './PageHeader';

export default function HomePageHeader({ breadCrumbs, ...props }) {
  const breadCrumbsWithHome = useMemo(
    () => [{ title: 'Home', url: '/' }, ...(breadCrumbs || [])],
    [breadCrumbs]);
  return (
    <PageHeader
      breadCrumbs={breadCrumbsWithHome}
      {...props} />);


}